// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"241125b1","867":"9c67a907"}[chunkId] + ".chunk.js";
};